const faQuestion = {
  prefix: 'fal',
  iconName: 'question',
  icon: [
    320,
    512,
    [10067, 10068, 61736],
    '3f',
    'M32 160C32 89.3 89.3 32 160 32S288 89.3 288 160c0 53.5-32.8 99.3-79.5 118.5-31.1 12.8-64.5 41-64.5 81.5l0 24c0 8.8 7.2 16 16 16s16-7.2 16-16l0-24c0-21.3 18.5-41.2 44.7-51.9 58.2-23.9 99.3-81.2 99.3-148.1 0-88.4-71.6-160-160-160S0 71.6 0 160c0 8.8 7.2 16 16 16s16-7.2 16-16zM160 512c13.3 0 24-10.7 24-24s-10.7-24-24-24-24 10.7-24 24 10.7 24 24 24z',
  ],
};
export default faQuestion;
